import { Text } from '@shared/components'
import { Flex, Popover, theme } from 'antd'
import { AnyObject } from 'antd/es/_util/type'
import { InfoCircle, ProfileCircle, Sms } from 'iconsax-react'

import { useTranslation } from 'react-i18next'

type Props = {
  responsible?: AnyObject
}

const infoItems = [
  { key: 'name', Icon: ProfileCircle },
  { key: 'email', Icon: Sms }
]

export const InfoPopover = ({ responsible }: Props) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  const content = responsible ? (
    <Flex vertical gap={12}>
      {infoItems.map(({ key, Icon }) => {
        const value = responsible[key]
        if (!value) return null

        return (
          <Flex key={key} align="center" gap={8}>
            <Icon size={20} />
            <Text>{value}</Text>
          </Flex>
        )
      })}
    </Flex>
  ) : (
    <Text>{t('no_responsible_assigned')}</Text>
  )

  return (
    <Popover content={content} placement="rightTop" trigger="hover">
      <InfoCircle size={20} color={token.colorInfo} />
    </Popover>
  )
}
